/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UpdateReassignmentDialog.vue?vue&type=template&id=6cc33808"
import script from "./UpdateReassignmentDialog.vue?vue&type=script&lang=js"
export * from "./UpdateReassignmentDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateReassignmentDialog.vue?vue&type=style&index=0&id=6cc33808&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc33808')) {
      api.createRecord('6cc33808', component.options)
    } else {
      api.reload('6cc33808', component.options)
    }
    module.hot.accept("./UpdateReassignmentDialog.vue?vue&type=template&id=6cc33808", function () {
      api.rerender('6cc33808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/doctors/UpdateReassignmentDialog.vue"
export default component.exports